import {useQuery} from 'react-query'
import {RequestuserEditModalForm} from './RequestuserEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
// import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'
import { getRequestuserById } from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../../_metronic/helpers'
// import { getRequestuserById } from '../../../apps/requestuser-management/requestusers-list/core/_requests'
// import {getRequestuserById} from '../core/_requests'

const RequestuserEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: requestuser,
    error,
  } = useQuery(
    `${QUERIES.REQUESTUSERS_LIST}-requestuser-${itemIdForUpdate}`,
    () => {
      return getRequestuserById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <RequestuserEditModalForm isRequestuserLoading={isLoading} requestuser={{id: undefined}} />
  }

  if (!isLoading && !error && requestuser) {
    return <RequestuserEditModalForm isRequestuserLoading={isLoading} requestuser={requestuser} />
  }

  return null
}

export {RequestuserEditModalFormWrapper}
